export default __webpack_public_path__ + "static/2281-a46af360e921c00a191d1c16c23e438e.gif";